/* eslint-disable no-multi-str */

import React, { useRef, useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    Box,
    Tooltip
} from '@mui/material';
import TextField from '@mui/material/TextField';
import RadioBoxGroup from '../../../../components/RadioButtons/RadioBoxGroup'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CustomDepartmentSelect from '../../../../pages/Member-Profile-Edit/CustomDepartmentSelect';
import ToggleSwitch from '../../../../components/ToggleSwitch/ToggleSwitch';
import InfoIcon from '@mui/icons-material/Info';
const labelStyle = {
    marginBottom: '4px',
    fontWeight: 600,
    color: '#1A1A1A',
    fontSize: '14px',
    fontFamily: 'Manrope'
};

const inputStyle = {
    height: '46px',
    backgroundColor: '#fff',
    fontSize: '13px',
    fontFamily: 'Manrope'
};

const industryOptions = [
    'By user, project, and date Jon doe-Development (Wed, Jan 1, 2025)', 'By project and date Development (Wed, Jan 1, 2025)', 'By user and project Jon doe-Development (Wed, Jan 1, 2025-Wed, Jan 8, 2025)',
]
const InvoicePage = ({ onCancel, onSave }) => {



    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState('')

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            // Optional: handle preview/upload
        }
    };


    const [frequencyOption, setFrequencyOption] = useState('')

    return (
        <form>
            <Box sx={{ marginBottom: '20px' }}>
                <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '20px', color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                    General
                </Typography>
                <Typography sx={{ fontSize: '12px', color: '#9095A1', fontWeight: '400', fontFamily: 'Manrope' }}>Modifications here will automatically refresh your organization's General settings.</Typography>
            </Box>
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 8, sm: 6 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Address <span style={{ color: 'black' }}>*</span>
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter Address "
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>
                {/* Job Type */}
                <Grid item size={{ xs: 12, md: 4, sm: 6 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="body2" sx={labelStyle}>
                                Tax ID <span style={{ color: 'black' }}>*</span>
                            </Typography>
                        </Box>
                        <Box sx={{ marginTop: '-12px' }}>
                            <Tooltip title="Serves as an identifier for your organization." arrow placement="top" alignContent="center">
                                <InfoIcon fontSize="small" sx={{ color: '#595959' }} />
                            </Tooltip>
                        </Box>
                    </Box>

                    <TextField
                        fullWidth
                        placeholder="Enter Tax ID "
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>


                <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography sx={{ m: '0 auto 4px', gap: '12px', fontSize: { xl: '17px', lg: '16px', md: '16px', sm: '16px', xs: '16px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                        Invoice logo
                    </Typography>
                    <Typography sx={{ fontSize: '12px', color: '#9095A1', marginBottom: '7px', fontWeight: '400', fontFamily: 'Manrope' }}>This is a logo used specifically for invoices, and will apply to all invoices made</Typography>
                    <Box display="flex" alignItems="center" sx={{ gap: 2 }}>
                        <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                        <Button onClick={handleButtonClick} variant="outlined" startIcon={<AttachFileIcon />}
                            sx={{
                                minWidth: '100%', borderRadius: '8px', borderColor: '#CC33FF', color: '#CC33FF', backgroundColor: '#CC33FF33', fontWeight: '600', fontSize: '14px', fontFamily: 'Manrope',
                                padding: '8px 16px', textTransform: 'none', '&:hover': { backgroundColor: '#F0CCF5', borderColor: '#DA33FF', },
                            }}>
                            Upload Logo
                        </Button>
                        {fileName && (
                            <Typography
                                sx={{
                                    marginTop: '0',
                                    fontSize: '14px',
                                    color: '#333',
                                    fontFamily: 'Manrope',
                                }}
                            >
                                Selected file: <strong>{fileName}</strong>
                            </Typography>
                        )}
                    </Box>
                </Grid>
                <Grid item size={{ xs: 12, md: 7 }}></Grid>
                <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography sx={{ m: '0 auto 4px', gap: '12px', fontSize: { xl: '17px', lg: '16px', md: '16px', sm: '16px', xs: '16px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                        Payment
                    </Typography>
                </Grid>
                <Grid item size={{ xs: 12, md: 5, lg: 4, sm: 5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Box>
                            <Typography variant="body2" sx={labelStyle}>
                                Tax Rate
                            </Typography>
                        </Box>
                        <Box sx={{ marginTop: '-12px' }}>
                            <Tooltip title="The tax percentage to be applied to the total invoice amount." arrow placement="top" alignContent="center">
                                <InfoIcon fontSize="small" sx={{ color: '#595959' }} />
                            </Tooltip>
                        </Box>
                    </Box>

                    <TextField
                        fullWidth
                        placeholder="Enter Tax Rate"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>
                <Grid item size={{ xs: 12, md: 7, lg: 4, sm: 7 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Box>
                            <Typography variant="body2" sx={labelStyle}>
                                Notes (Shown on invoices)
                            </Typography>
                        </Box>
                        <Box sx={{ marginTop: '-12px' }}>
                            <Tooltip title="Displayed as a message on invoices when no client-specific notes are provided." arrow placement="top" alignContent="center">
                                <InfoIcon fontSize="small" sx={{ color: '#595959' }} />
                            </Tooltip>
                        </Box>
                    </Box>

                    <TextField
                        fullWidth
                        placeholder="Enter Notes"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>
                <Grid item size={{ xs: 12, md: 12, lg: 4, sm: 12 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Box>
                            <Typography variant="body2" sx={labelStyle}>
                                New Terms
                            </Typography>
                        </Box>
                        <Box sx={{ marginTop: '-12px' }}>
                            <Tooltip title="Amount of days the invoice must be paid once created" arrow placement="top" alignContent="center">
                                <InfoIcon fontSize="small" sx={{ color: '#595959' }} />
                            </Tooltip>
                        </Box>
                    </Box>

                    <TextField
                        fullWidth
                        placeholder="Enter Net Terms"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography sx={{ m: '0 auto 4px', gap: '12px', fontSize: { xl: '17px', lg: '16px', md: '16px', sm: '16px', xs: '16px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                        Payment button
                    </Typography>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        PayPal Email
                    </Typography>
                    <TextField
                        fullWidth
                        placeholder="Enter  your business’s  PayPal email address"
                        variant="outlined"
                        InputProps={{ sx: inputStyle }}
                    />
                    <Typography sx={{ fontSize: '12px', color: '#9095A1', fontWeight: '400', marginTop: '5px', fontFamily: 'Manrope' }}>Easily accept payments from clients with PayPal</Typography>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box>
                            <Typography sx={{ m: '0 auto 4px', gap: '12px', fontSize: { xl: '17px', lg: '16px', md: '16px', sm: '16px', xs: '16px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                                Auto invoicing
                            </Typography>
                            <Typography sx={{ fontSize: '12px', color: '#9095A1', fontWeight: '400', marginTop: '5px', fontFamily: 'Manrope' }}>These settings will be applied to all clients unless explicitly disabled or custom settings are applied.</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box>
                                <RadioBoxGroup
                                    options={['Off', 'On']}
                                    defaultValue="None"
                                    row={true}
                                />
                            </Box>
                            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type='text' className='form-control' style={{height: '40px' , width: '140px'}} />
                                <label>USD</label>
                            </Box> */}
                        </Box>
                    </Box>
                </Grid>
                <Grid item size={{ xs: 12, md: 12 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box>
                            <Typography display="flex" alignItems="center" sx={labelStyle}>
                                Amount based on
                            </Typography>

                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box>
                                <RadioBoxGroup
                                    options={['Hourly', 'Fixed price']}
                                    defaultValue="None"
                                    row={true}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input type='text' className='form-control' style={{ height: '40px', width: '100px' }} />
                                <label>USD</label>
                            </Box>
                        </Box>
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Frequency
                    </Typography>
                    <Box>
                        <FormControl fullWidth>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={frequencyOption}
                                displayEmpty
                                onChange={(e) => setFrequencyOption(e.target.value)}
                                sx={labelStyle}  >
                                <MenuItem value={""}>Monthly</MenuItem>
                                <MenuItem value={20}>Bi-Weekly</MenuItem>
                                <MenuItem value={30}>Weekly</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Box>
                            <Typography variant="body2" sx={labelStyle}>
                                Delay Sending
                            </Typography>
                        </Box>
                        <Box sx={{ marginTop: '-12px' }}>
                            <Tooltip title="Delays invoice sending, allowing you to review and edit draft invoices before they are sent." arrow placement="top" alignContent="center">
                                <InfoIcon fontSize="small" sx={{ color: '#595959' }} />
                            </Tooltip>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Box sx={{ width: '100%' }}>
                            <TextField
                                fullWidth
                                placeholder="Enter No of Days"
                                variant="outlined"
                                InputProps={{ sx: inputStyle }}
                            />
                        </Box>
                        <Box>
                            <Typography sx={labelStyle}>Days</Typography>
                        </Box>
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Box>
                            <Typography variant="body2" sx={labelStyle}>
                                Send reminder to pay after due
                            </Typography>
                        </Box>
                        <Box sx={{ marginTop: '-12px' }}>
                            <Tooltip title="This feature will dispatch a courteous reminder email following the due date, informing your client that the invoice remains unpaid and is now overdue." arrow placement="top" alignContent="center">
                                <InfoIcon fontSize="small" sx={{ color: '#595959' }} />
                            </Tooltip>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Box sx={{ width: '100%' }}>
                            <TextField
                                fullWidth
                                placeholder="Enter Reminder"
                                variant="outlined"
                                InputProps={{ sx: inputStyle }}
                            />
                        </Box>
                        <Box>
                            <Typography sx={labelStyle}>Days</Typography>
                        </Box>
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Typography variant="body2" sx={labelStyle}>
                        Line items
                    </Typography>
                    <Box>
                        <CustomDepartmentSelect selectedPlaceholder="By user, project, and date" modalSearchplaceHolder="Search" initialOptions={industryOptions} showAddOption={false} />
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box>
                            <Typography variant="body2" sx={labelStyle}>
                                Include non-billable time
                            </Typography>
                        </Box>
                        <Box>
                            <ToggleSwitch />
                        </Box>
                    </Box>
                </Grid>
                <Grid item size={{ xs: 12, md: 12 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box>
                            <Typography variant="body2" sx={labelStyle}>
                                Include expenses
                            </Typography>
                        </Box>
                        <Box>
                            <ToggleSwitch />
                        </Box>
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        sx={{
                            fontSize: '14px',
                            borderRadius: '50px',
                            background: '#fff',
                            border: '1px solid #9095A1',
                            color: '#9095A1',
                        }}
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            fontSize: '14px',
                            borderRadius: '50px',
                            background: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                        }}
                        onClick={onSave}
                    >
                        Save
                    </Button>
                </Grid>
            </Grid  >
        </form >
    );
};

export default InvoicePage;
